<template>
  <v-select
    :options="options"
    :selectName="selectName"
    :selectId="selectId"
    :value="modelValue"
    @input="$emit('update:modelValue', $event.target.value)"
    required
  ></v-select>
</template>

<script>
import vendorStatusesApi from "@/api/resources/vendorStatusesApi";
import VSelect from "@/components/ui/VSelect.vue";

export default {
  props: {
    selectName: String,
    selectId: String,
    modelValue: [String, Number],
  },
  emits: ["update:modelValue"],
  components: { VSelect },

  data() {
    return {
      options: [],
    };
  },

  methods: {
    getVendorStatuses() {
      vendorStatusesApi.index().then((response) => {
        this.options = response.data.map((status) => {
          return { text: status.label, value: status.id };
        });
      });
    },
  },

  created() {
    this.getVendorStatuses();
  },
};
</script>

<style></style>
